import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AiChatService } from '@app/core/services/ai-chat.service';
import { AiChatItem } from '@app/core/services/ai-chat.types';
import { Observable } from 'rxjs';
import { ContextMenuAction } from '../../context-menu/context-menu.service';

@Component({
    selector: 'tt-ai-chat-conversation-list',
    templateUrl: './ai-chat-conversation-list.component.html',
    styleUrls: ['./ai-chat-conversation-list.component.css'],
    standalone: false,
})
export class AiChatConversationListComponent {
    public readonly providerNamesByKeyno$: Observable<Record<string, string>> = this.aiChat.providerNamesByKeyno$;

    @Input()
    public chats: AiChatItem[] = [];

    @Input()
    public selectedChat?: AiChatItem;

    @Input()
    public loading = false;

    @Output()
    public chatSelected = new EventEmitter<AiChatItem>();

    @Input() public busyChatKeyno?: string;
    @Input() public actionError = '';
    @Output() public archiveChat = new EventEmitter<AiChatItem>();
    @Output() public renameChat = new EventEmitter<AiChatRenameEvent>();
    public renamingChat?: AiChatItem;
    public renameName = '';
    public readonly renameInputId = 'ai-chat-rename-' + crypto.randomUUID();

    @ViewChild('renameInput')
    set renameInput(input: ElementRef<HTMLInputElement> | undefined) {
        if (input) queueMicrotask(() => {
            if (input.nativeElement.isConnected) {
                input.nativeElement.focus();
                input.nativeElement.select();
            }
        });
    }

    constructor(private aiChat: AiChatService, private element: ElementRef<HTMLElement>) {}

    public beginRename(action: ContextMenuAction): void {
        const chat = this.contextChat(action);
        if (!chat || this.busyChatKeyno) return;
        this.renamingChat = chat;
        this.renameName = chat.ai_chat_name ?? '';
    }

    public requestArchive(action: ContextMenuAction): void {
        const chat = this.contextChat(action);
        if (chat && !this.busyChatKeyno) this.archiveChat.emit(chat);
    }

    public saveRename(): void {
        const chat = this.renamingChat, name = this.renameName.trim();
        if (!chat || this.busyChatKeyno || !name || name.length > 300) return;
        if (name === chat.ai_chat_name) this.finishRename(chat.ai_chat_keyno);
        else this.renameChat.emit({ chat, name });
    }

    public cancelRename(event?: Event): void {
        event?.preventDefault();
        if (!this.busyChatKeyno && this.renamingChat) this.finishRename(this.renamingChat.ai_chat_keyno);
    }

    public finishRename(chatKeyno: string): void {
        if (this.renamingChat?.ai_chat_keyno !== chatKeyno) return;
        this.renamingChat = undefined;
        this.renameName = '';
        queueMicrotask(() => this.element.nativeElement.querySelector<HTMLButtonElement>('[data-chat-keyno="' + chatKeyno + '"]')?.focus());
    }

    private contextChat(action: ContextMenuAction): AiChatItem | undefined {
        return this.chats.find(chat => chat === action.context);
    }

    public trackChat(_index: number, chat: AiChatItem): string {
        return chat.ai_chat_keyno;
    }
}

export interface AiChatRenameEvent {
    chat: AiChatItem;
    name: string;
}
